import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { CS_QNA_PAGE_NAME } from '../../../constants/service/app/csQnaConstants';
import CsInQnaListWrap from '../../../views/cs/qna/list/CsInQnaListWrap';

const CsQnaList = () => {
  return (
    <PageTemplate pageName={CS_QNA_PAGE_NAME.QNA_LIST}>
      <CsInQnaListWrap />
    </PageTemplate>
  );
};

export default CsQnaList;
